import React, { useState } from 'react';
import { StepContainer, StepNavigation, ChoiceButtons } from '../components';
import { StepProps, useFormContext } from '../context';

export const Step20C_InteresseXizinha: React.FC<StepProps> = ({ onNext, onPrevious, isLoading }) => {
  const { data, updateField } = useFormContext();
  const [errors, setErrors] = useState<Record<string, string>>({});

  const handleNext = () => {
    const newErrors: Record<string, string> = {};

    if (!data.xizinhaInterest) newErrors.xizinhaInterest = 'Campo obrigatório';

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    onNext({ xizinhaInterest: data.xizinhaInterest });
  };

  const handleFieldChange = (value: string) => {
    updateField('xizinhaInterest', value);
    if (errors.xizinhaInterest) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors.xizinhaInterest;
        return newErrors;
      });
    }
  };

  return (
    <StepContainer title="">
      <div className="mb-6">
        <p className="font-semibold mb-4">Qual é o seu grau de interesse em utilizar a ferramenta de vendas Xizinha?</p>
      </div>
      <div>
        <ChoiceButtons
          options={[
            { label: 'Muito interessada — quero aprender o app para facilitar minhas vendas.', value: 'very-interested' },
            { label: 'Interessada — usaria o app com orientação ou suporte inicial.', value: 'interested' },
            { label: 'Pouco interessada — prefiro fazer as vendas de forma mais tradicional (mensagens, catálogo, anotações de vendas em caderneta, etc.).', value: 'not-interested' },
          ]}
          selected={data.xizinhaInterest || ''}
          onSelect={handleFieldChange}
        />
        {errors.xizinhaInterest && (
          <p className="text-red-600 text-sm mt-2">{errors.xizinhaInterest}</p>
        )}
      </div>

      <StepNavigation onPrevious={onPrevious} onNext={handleNext} isLoading={isLoading} />
    </StepContainer>
  );
};

export default Step20C_InteresseXizinha;
